import React, { useState, useEffect } from 'react';
import { MdOutlinePhone } from "react-icons/md";
import { TiTick } from "react-icons/ti";
import { MdPhoneIphone } from "react-icons/md";
import { LuLaptopMinimalCheck } from "react-icons/lu";
import "./SettingsAlertPanel.scss"

export default function SettingsAlertPanelComponent({ isMobile, mainProps, showSidebar }) {
    const { main, mainLoading, mainError } = mainProps;
    const [showPhone, setShowPhone] = useState(false);
    const [maskedPhone, setMaskedPhone] = useState('');

    const phoneNo = main?.user?.detail?.otp_phone_nr || "";

    useEffect(() => {
        if (showPhone) {
            setMaskedPhone(phoneNo);
        } else {
            const masked = phoneNo.slice(0, -4).replace(/\d/g, '*') + phoneNo.slice(-4);
            setMaskedPhone(masked);
        }
    }, [showPhone, phoneNo]);

    return (
        <>
            <div
                className="container-fluid bg-col transition-width"
                style={
                    !isMobile
                        ? {
                            width: showSidebar ? 'calc(100% - 332px)' : '100%',
                            marginLeft: 0,
                            marginRight: 'auto',
                            transition: showSidebar ? 'width 0.3s ease-in-out' : 'width 0.16s ease-in-out'
                        } : {}
                }
            >
                <div className="row p-3 reports-panel" style={{ borderBottom: "2px solid #EFEFEF" }}>
                    <h5 className="mb-5 mt-2" style={{ fontWeight: "500" }}>ALERT PANEL</h5>

                    <h5>Alarm Receiving Channels</h5>
                    <div className='w-100 mb-4 table-responsive-custom'>
                        <table className="table table-xxl mt-2 border">
                            <thead>
                                <tr className='table-head py-4'>
                                    <th>Phone Number</th>
                                    <th>Notification-enabled devices</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <div
                                            onClick={() => setShowPhone(!showPhone)}
                                            style={{
                                                fontFamily: 'monospace',
                                                minWidth: '160px',
                                                display: 'inline-block',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            <MdOutlinePhone size={25} style={{ color: "#6A343A", marginRight: '5px' }} />
                                            {maskedPhone}
                                        </div>
                                    </td>
                                    <td >
                                        {isMobile ? (
                                            <MdPhoneIphone size={30} style={{ color: "#6A343A" }} />
                                        ) : (
                                            <LuLaptopMinimalCheck size={30} style={{ color: "#6A343A" }} />
                                        )}
                                        <strong>{isMobile ? ' MO' : ' DT'}</strong>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <h5>Default Alarms</h5>
                    <div className='w-100 mb-4 table-responsive-custom'>
                        <table className="table table-xxl mt-2 border">
                            <thead>
                                <tr className='table-head py-4'>
                                    <th style={{ width: "70%" }}>Description of the alarm message</th>
                                    <th className='text-center' style={{ width: "10%" }}>SMS</th>
                                    <th className='text-center' style={{ width: "10%" }}>Email</th>
                                    <th className='text-center' style={{ width: "10%" }}>System</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>The 'Not Executed' service allows you ti receive an email alert if a payment is not made successfully</td>
                                    <td className="text-center"></td>
                                    <td className="text-center"><TiTick size={21} style={{ color: "#6A343A" }} /></td>
                                    <td className="text-center"><TiTick size={21} style={{ color: "#6A343A" }} /></td>
                                </tr>
                                <tr>
                                    <td>2FA (Two factor authentication)</td>
                                    <td className="text-center"><TiTick size={21} style={{ color: "#6A343A" }} /></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                </tr>
                                <tr>
                                    <td>Payment Legal Information</td>
                                    <td className="text-center"></td>
                                    <td className="text-center"><TiTick size={21} style={{ color: "#6A343A" }} /></td>
                                    <td className="text-center"></td>
                                </tr>
                                <tr>
                                    <td>Login from a new device or location</td>
                                    <td className="text-center"><TiTick size={21} style={{ color: "#6A343A" }} /></td>
                                    <td className="text-center"><TiTick size={21} style={{ color: "#6A343A" }} /></td>
                                    <td className="text-center"><TiTick size={21} style={{ color: "#6A343A" }} /></td>
                                </tr>
                                <tr>
                                    <td>Suspicious activity detected (e.g., failed login attempts)</td>
                                    <td className="text-center"><TiTick size={21} style={{ color: "#6A343A" }} /></td>
                                    <td className="text-center"><TiTick size={21} style={{ color: "#6A343A" }} /></td>
                                    <td className="text-center"></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <h5>Account Alarms</h5>
                    <div className='w-100 mb-4 table-responsive-custom'>
                        <table className="table table-xxl mt-2 border">
                            <thead>
                                <tr className='table-head py-4'>
                                    <th style={{ width: "70%" }}>Description of the alarm message</th>
                                    <th className='text-center' style={{ width: "10%" }}>SMS</th>
                                    <th className='text-center' style={{ width: "10%" }}>Email</th>
                                    <th className='text-center' style={{ width: "10%" }}>System</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td colSpan="4" className="text-center py-4">
                                        The current account no. <strong>{main?.user?.detail?.account_number?.replace(/^.*?-/, '')}</strong> is registered in the name of <strong>{main?.user?.first_name?.toUpperCase()} {main?.user?.last_name?.toUpperCase()}</strong> and is solely payable to them.
                                    </td>
                                </tr>
                                <tr>
                                    <td>Two-Factor Authentication (2FA) for Secure Login</td>
                                    <td className="text-center"><TiTick size={21} style={{ color: "#6A343A" }} /></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                </tr>
                                <tr>
                                    <td>Authorization and Activation of Direct Debit Mandates</td>
                                    <td className="text-center"></td>
                                    <td className="text-center"><TiTick size={21} style={{ color: "#6A343A" }} /></td>
                                    <td className="text-center"></td>
                                </tr>
                                <tr>
                                    <td>Handling of Failed or Rejected Direct Debit Transactions</td>
                                    <td className="text-center"></td>
                                    <td className="text-center"><TiTick size={21} style={{ color: "#6A343A" }} /></td>
                                    <td className="text-center"></td>
                                </tr>
                                <tr>
                                    <td>Daily Transaction Limits and Spending Controls</td>
                                    <td className="text-center"><TiTick size={21} style={{ color: "#6A343A" }} /></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"><TiTick size={21} style={{ color: "#6A343A" }} /></td>
                                </tr>
                                <tr>
                                    <td>Digital Signature for Document and Payment Authorization</td>
                                    <td className="text-center"><TiTick size={21} style={{ color: "#6A343A" }} /></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
            </div >
        </>
    );
}